WYATT.registerComponent(
  "mosaic-expander",
  class MosaicExpander extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector("button");

      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      const block = this.closest(".mosaic__block--compress-blocks");

      if (block) {
        block.classList.remove("mosaic__block--compress-blocks");
      }
    }
  }
);
